require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-meaningful-stakeholder-engagement-and-social-inclusion.json") })
        }
      }, "path---en-us-update-meaningful-stakeholder-engagement-and-social-inclusion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-meaningful-stakeholder-engagement-and-social-inclusion!./.cache/json/en-us-update-meaningful-stakeholder-engagement-and-social-inclusion.json
// module id = 773
// module chunks = 231608221292675